import { ResponseForTable } from '../tables/response-for-table';
import { TableItem } from '../tables/table-item';

export enum ProductId {
  pa = 'pa',
  tp = 'tp',
  web = 'web',
  ct = 'ct'
}

export enum CategoryIdTest {
  bonuses = 1,
  accounts = 3,
  general = 5
}

export enum CategoryIdProd {
  bonuses = 1,
  accounts = 2,
  general = 3
}

export interface Product {
  id: ProductId;
  name: string;
}

export interface Category {
  id: number; // id отличаются в зависимости от тест и прод окружений
  name: string;
}

export interface Template {
  id: number; // id отличаются в зависимости от тест и прод окружений
  name: string;
  page: string; // url
  isForPartners: boolean;
}

export interface QrCode {
  pngUri: string;
  pngWithKeywordUri: string;
  pdfUri: string;
  pdfWithKeywordUri: string;
}

export interface ReferralLink extends TableItem {
  id: number;
  url: string;
  urlWithKeyword: string;
  lang: string;
  minRebatePercent: number;
  clicks: number;
  demoAccounts: number;
  realAccounts: number;
  partnerAccounts: number;
  accountUsers: number;
  registrations: number;
  createdAt: string;
  updatedAt: string;
  product: Product;
  category: Category;
  template: Template;
  qrCode: QrCode;
  isJustCreated?: boolean; // frontend
}

export interface ReferralLinkRequest {
  lang: string;
  templateId: string;
  domain?: string;
  bannerId?: number;
  minRebatePercent?: number;
}

export interface LinksStats<T extends TableItem> extends ResponseForTable<T> {
  realAccountsCount: number;
  demoAccountsCount: number;
  partnerAccountsCount: number;
}

export interface LinkGroupRow extends TableItem {
  groupRow: LinkGroup;
}

export enum LinkGroup {
  top = 'top',
  other = 'other'
}

export interface ReferralLinkStat extends ReferralLink {
  commission: number;
  followerPartnerCommission: number;
  deposits: number;
  depositsCount: number;
  statClicks: number;
  statRegistrations: number;
  statRealAccounts: number;
  statDemoAccounts: number;
  firstClickAt: string;
  bannerName: string;
}
